var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"error-page",attrs:{"justify":"center","align":"center"}},[_c('span',{staticClass:"error-page--status"},[_vm._v(_vm._s(_vm.$route.params.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }